module.exports = __webpack_public_path__ + "img/bg_icon3.df0390ae.png";